
const fetch = require("node-fetch");

export default async function () {
  const request = await fetch("https://api.lever.co/v0/postings/YesHearing?mode=json");
  const jobs = await request.json()

  return jobs
}
